import { PortfolioMenu } from '@unistocks/features/portfolios/components/portfolio-settings/portfolio-menu';
import { useWatchlistsGetQuery } from '@unistocks/proxy/axios-client/WatchlistsQuery';
import { HasId } from '@unistocks/types/has-id';
import { memo } from 'react';

export const WatchlistHeaderRight = memo<HasId>(({ id }) => {
  const { data: watchlist, isSuccess } = useWatchlistsGetQuery({ id });

  return isSuccess ? <PortfolioMenu portfolio={watchlist} /> : null;
});

WatchlistHeaderRight.displayName = 'WatchlistHeaderRight';
